import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useAverageTransactionValueList } from "Hooks/Options/useAverageTransactionValueList";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
};

export const AverageTransactionValueDropdown = <
  T extends object,
  V extends object,
>({
  control,
  name,
  label,
}: Props<T, V>) => {
  const codeList = useAverageTransactionValueList();

  return (
    <Dropdown codeList={codeList} name={name} control={control} label={label} />
  );
};
